import '@aofl/picture';

export default (ctx, html) => html`
  <div id="back-container" @click="${(e) => ctx.goBack(e)}">
    <span id="back-button-focus" class="enteractive tab-outline-blue" tabindex="0"  aria-label="Go back to previous page." @click="${(e) => ctx.goBack(e)}"></span>
    <div id="back-arrow"></div>
    <span id="back-text">Back</span>
  </div>
`;
